import page33 from "./Page33.webp";
import page34 from "./Page34.webp";
import page35 from "./Page35.webp";
import page36 from "./Page36.webp";
import page37 from "./Page37.webp";
import page38 from "./Page38.webp";
import page39 from "./Page39.webp";
import page40 from "./Page40.webp";
import page41 from "./Page41.webp";

export const neoPages = [
  page33,
  page34,
  page35,
  page36,
  page37,
  page38,
  page39,
  page40,
  page41,
];
